import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppCalendarService } from 'src/app/views/event/app-calendar/app-calendar.service';
import { CalendarFormDialogComponent } from 'src/app/views/event/app-calendar/calendar-form-dialog/calendar-form-dialog.component';
import { TodosService } from 'src/app/views/event/todos/todos.service';
import { SkillztankCalendarEvent } from '../../../shared/models/event.model';
import { AppConfirmService } from '../../../shared/services/app-confirm/app-confirm.service';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';
import { ToastService } from '../../../shared/services/toast/toast.service';

@Component({
  selector: 'app-todo-table',
  templateUrl: './todo-table.component.html',
  styleUrls: ['./todo-table.component.scss'],
  standalone: false,
})
export class TodoTableComponent implements OnInit {
  @Input() data;
  @Input() alwaysVisible;
  @Output() onEditEvent = new EventEmitter<any>();
  constructor(
    private todosService: TodosService,
    private toast: ToastService,
    private errorHandler: ErrorHandlerService, // private socketService: SocketsService,
    private dialog: MatDialog,
    private calendarService: AppCalendarService,
    private breakpointObserver: BreakpointObserver,
    private translate: TranslateService,
    private bottomSheet: MatBottomSheet,
    private confirmService: AppConfirmService
  ) {}

  ngOnInit() {}

  createTodo() {
    this.addEvent();
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.container.id == 'delete') {
      this.todosService.deleteTodo((event.previousContainer.data[event.previousIndex] as any)._id).subscribe((res) => {
        this.todosService.passTodoData({});
        //  this.socketService.emitEvent('todo-event', { info: 'deleted-todo' })
      });
    } else {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else if (event.previousContainer.id != event.container.id) {
        this.todosService.editTodo((event.previousContainer.data[event.previousIndex] as any)._id, event.container.id).subscribe({
          complete: () => {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
            this.onEditEvent.emit();
            // this.socketService.emitEvent('todo-event', { info: 'edited-todo' })
            // this.toast.snackbar.open(`Saved!`, 'OK', { duration: 4000 })
          },
          error: (err) => {
            transferArrayItem(
              event.container.data, // go back
              event.previousContainer.data,
              event.currentIndex,
              event.previousIndex
            );
            if (!this.errorHandler.handle401Error(err)) {
              this.toast.snackbar.open(this.translate.instant('Snackbar.TodoErrorWhileMoving'), 'Close', {
                duration: 2000,
              });
            }
          },
        });
      }
    }
  }

  openPopContent(todo) {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    let container;
    if (isSmallScreen) {
      container = this.bottomSheet;
    } else {
      container = this.dialog;
    }
    // if (todo.contentID) {
    const ref = container.open(CalendarFormDialogComponent, {
      data: {
        contentID: todo.contentID,
        todoID: todo._id,
        event: new SkillztankCalendarEvent(todo),
        action: 'edit',
      },
      minWidth: '500px',
      maxWidth: '60vw',
      maxHeight: '80vh',
    });
    const onCloseSub = ref.afterClosed ? ref.afterClosed() : ref.afterDismissed();
    onCloseSub.subscribe((res) => {
      if (!res) {
        return;
      }
      const dialogAction = res.action;
      const responseEvent = res.event;
      if (dialogAction === 'edit') {
        this.calendarService.updateEvent(responseEvent).subscribe();
      } else if (dialogAction === 'delete') {
        this.removeEvent(responseEvent);
      } else if (dialogAction == 'delete-all-occurrences') {
        this.removeAllOccurrencesOfEvent(responseEvent);
      }
    });
  }

  public addEvent() {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    let container;

    if (isSmallScreen) {
      container = this.bottomSheet;
    } else {
      container = this.dialog;
    }

    const ref = container.open(CalendarFormDialogComponent, {
      panelClass: 'calendar-form-dialog',
      data: {
        action: 'add',
        date: new Date(),
      },
      minWidth: '500px',
      maxWidth: '60vw',
      maxHeight: '80vh',
    });

    (ref.afterClosed ? ref.afterClosed() : ref.afterDismissed()).subscribe((res) => {
      //  this.socketService.emitEvent('todo-event', { info: 'new-todo' })
      if (!res) {
        return;
      }

      const dialogAction = res.action;
      const responseEvent = res.event;
      delete responseEvent._id;
      this.calendarService.addEvent(responseEvent).subscribe((events) => {
        this.todosService.passTodoData({});
      });
      // this.todosService.passTodoData({})
    });
  }

  public removeEvent(event) {
    this.confirmService
      .confirm({
        title: this.translate.instant('Calendar.Confrim.DeleteEvent'),
      })
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.calendarService.deleteEvent(event._id).subscribe();
      });
  }

  public removeAllOccurrencesOfEvent(event) {
    this.confirmService
      .confirm({
        title: this.translate.instant('Calendar.Confrim.DeleteAllOccurrecneOfEvent'),
      })
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.calendarService.deleteAllOccurrenceOfEvent(event._id).subscribe();
      });
  }
}
